import { useEffect } from "react";
function useOnVerticalVisibilityChange(target, callback) {
  const visible = target ? target.scrollHeight > target.clientHeight : false;
  useEffect(() => {
    callback?.(visible);
  }, [visible, callback]);
}
export {
  useOnVerticalVisibilityChange
};
//# sourceMappingURL=useOnVerticalVisibilityChange.js.map
